import styled from 'styled-components';

/** Centred loading shell for the PDF export screen (hidden in print). */
export const PdfExportLoadingState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 48px 24px;
  font-family: 'Mulish', sans-serif;
  color: #555;
`;

/** Centred error shell for the PDF export screen (hidden in print). */
export const PdfExportErrorState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 48px 24px;
  font-family: 'Mulish', sans-serif;
  color: #555;
`;
